import React from 'react';

import classes from './OnboardingSteps.module.scss';

const STEPS = [
    { number: 1, label: 'Upload your CV' },
    { number: 2, label: 'Start a course' },
    { number: 3, label: 'Your radar appears' }
];

const OnboardingSteps = () => {
    return (
        <div className={classes['steps-wrapper']}>
            {STEPS.map((step) => (
                <div key={step.number} className={classes['step']}>
                    <span className={classes['step-number']}>{step.number}</span>
                    <span className={classes['step-label']}>{step.label}</span>
                </div>
            ))}
        </div>
    );
};

export default OnboardingSteps;
